import { Controller } from "@hotwired/stimulus"

// The monogram at the head of the composer, for a member with two faces: a
// tap turns it over, from the name they write under to their own name and
// back, and the post is signed with whichever shows. A post in their own name
// goes only to their circle, so choosing it also points the post there and
// closes the choices that would carry the name further; turning back opens
// them again. The field the server reads is a hidden input; the monograms
// are its two faces.
export default class extends Controller {
  static targets = ["field", "button", "mark", "select", "label"]
  static values = {
    publicName: String,
    circleName: String,
    // The button's title in each state, set by the page in the reader's language.
    ownTitle: String,
    publicTitle: String
  }

  connect() {
    this.apply(this.fieldTarget.value || "public_face")
  }

  toggle() {
    this.apply(this.own ? "public_face" : "circle_face")
    this.buttonTarget.focus()
  }

  // The destination changed by hand. Nothing to do while the name they write
  // under is showing; in their own name the far choices are closed already.
  destinationChanged() {
    if (this.own && this.travelsFar(this.selectTarget.value)) this.apply("public_face")
  }

  apply(face) {
    this.fieldTarget.value = face
    const own = face === "circle_face"

    this.markTargets.forEach((mark) => (mark.hidden = mark.dataset.personaFace !== face))
    this.buttonTarget.setAttribute("aria-pressed", String(own))
    this.buttonTarget.title = own ? this.ownTitleValue : this.publicTitleValue
    if (this.hasLabelTarget) this.labelTarget.hidden = !own

    if (!this.hasSelectTarget) return
    for (const option of this.selectTarget.options) {
      option.disabled = own && this.travelsFar(option.value)
    }
    if (own && this.travelsFar(this.selectTarget.value)) {
      this.selectTarget.value = "followers"
      this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  travelsFar(destination) {
    return destination === "everyone" || destination.startsWith("circle:")
  }

  get own() {
    return this.fieldTarget.value === "circle_face"
  }
}
